/* eslint-disable no-console */
import { validate } from '../../utils/form-validation-utils';

// console.log('\n\n\n****************************\n\nadd-product-new.js ver: 0.0.6\n\n****************************\n\n\n');

const addProducts = () => {
  if (document.querySelector('.pr-add-products-form') === null) {
    return;
  }

  const form = document.querySelector('.pr-add-products-form');
  const findOrderBtn = form.querySelector('.o-form__submit');
  const completeRegistrationBtn = document.querySelector('.complete-registration-btn');
  const productsWrapper = form.querySelector('.product-items');
  const defaultErrorMsg = form.querySelector('.default-error-message');
  const duplicateItemsErrorMsg = form.querySelector('.duplicate-items-error-message');
  const unsavedItemsErrorMsg = form.querySelector('.unsaved-items-error-message');
  const mulitpleLineItemsMsg = form.querySelector('.mulitple-line-items-message');
  const orderData = {
    storeGroup: null,
    storeGroupDescription: null,
  };

  const checkForSessionData = () => {
    const { sessionStorage } = window;
    const sessionObj = sessionStorage.getItem('bali_ppData');
    if (sessionObj !== null) {
      return true;
    }
    return false;
  };

  if (!checkForSessionData() && !window.isAuthenticated) {
    document.querySelector('.pr-add-products-form').classList.add('hidden');
    document.querySelector('.no-active-registration-content').classList.remove('hidden');
    return;
  }

  const getProductCodeEntry = () => (
    productsWrapper.querySelector('#order-number-1').value
  );

  const getUserId = () => {
    const { userId } = window;
    let id = userId;
    if (isNaN(id)) { /* eslint-disable-line no-restricted-globals */
      const { sessionStorage } = window;
      const sessionObj = sessionStorage.getItem('bali_userId');
      if (sessionObj !== null) {
        id = JSON.parse(sessionObj).userId;
      }
    }
    return id;
  };

  const setStoreGroupValues = (data) => {
    if (!orderData.storeGroup) {
      orderData.storeGroup = data['store-group'];
    }
    if (!orderData.storeGroupDescription) {
      orderData.storeGroupDescription = data['store-group-description'];
    }
  };

  const disableUiBtn = (options) => {
    const {
      btn,
      label,
      className,
    } = options;
    if (className) {
      btn.classList.add(className);
    } else {
      btn.classList.add('o-form__submit--disabled');
    }
    btn.setAttribute('disabled', 'disabled');
    if (label) {
      btn.innerHTML = label;
    }
  };

  const enableUiBtn = (options) => {
    const {
      btn,
      label,
      className,
    } = options;
    if (className) {
      btn.classList.remove(className);
    } else {
      btn.classList.remove('o-form__submit--disabled');
    }
    btn.removeAttribute('disabled');
    if (label) {
      btn.innerHTML = label;
    }
  };

  const removeSaveResponseMessages = () => {
    defaultErrorMsg.classList.add('hide');
    duplicateItemsErrorMsg.classList.add('hide');
    unsavedItemsErrorMsg.classList.add('hide');
    mulitpleLineItemsMsg.classList.add('hide');
  };

  const displaySaveResponseMessages = (response) => {
    const { errorType, multipleItemsPerLine } = response;
    /*
      Error Codes:
      0: Order number <ORDER NUMBER> is incorrect. Please recheck the number and try again.
      1:
      2:
      3:
      4: Duplicate Registration
      5: Product registered
    */
    switch (errorType) {
      case 0:
      case 1:
      case 2:
      case 3:
        defaultErrorMsg.classList.remove('hide');
        break;
      case 4:
        duplicateItemsErrorMsg.classList.remove('hide');
        break;
      case 5:
        if (multipleItemsPerLine) {
          mulitpleLineItemsMsg.classList.remove('hide');
        }
        break;
      default:
        defaultErrorMsg.classList.remove('hide');
    }
  };

  const onOrderNumberLookupSuccess = (responseData) => {
    document.querySelector('.pr-add-products-form-container').classList.add('hidden');
    document.querySelector('.complete-registration-content').classList.remove('hidden');

    const currentBubble = document.querySelector('.bubble-current');
    currentBubble.classList.add('bubble-visited');
    currentBubble.classList.remove('bubble-current');
    currentBubble.nextElementSibling.classList.add('bubble-current');
    currentBubble.nextElementSibling.classList.remove('bubble-unvisited');

    // Populate items
    const lineItemsDiv = document.querySelector('.order-line-item-list');
    const leadingZeros = '00';
    const lineItems = responseData['line-items'];
    for (let i = 0; i < lineItems.length; i++) { /* eslint-disable-line no-plusplus */
      const lineItem = lineItems[i];
      const lineItemContainer = document.createElement('div');
      lineItemContainer.classList.add('d-flex', 'mt-3');
      const zeroCt = 3 - lineItem['line-number'].toString().length;
      const item = `${responseData['order-number']}.${leadingZeros.substr(0, zeroCt)}${lineItem['line-number']}`;
      const itemNumber = document.createElement('div');
      itemNumber.classList.add('col-5');
      itemNumber.innerHTML = item;
      const itemName = document.createElement('div');
      itemName.classList.add('col-7');
      itemName.innerHTML = lineItem.description;
      lineItemContainer.append(itemNumber);
      lineItemContainer.append(itemName);
      lineItemsDiv.append(lineItemContainer);
    }
  };

  const orderNumberLookup = (event) => {
    event.preventDefault();
    if (!validate(form)) {
      return;
    }
    // Disable buttons
    const defaultBtnLabel = findOrderBtn.textContent;
    disableUiBtn({
      btn: findOrderBtn,
      className: 'btn--disabled',
      label: 'Searching...',
    });
    const { addProductsEndpoint } = window;
    // Get order number from adjacent input
    const OrderNumber = getProductCodeEntry();
    // Remove any messaging
    removeSaveResponseMessages();
    const requestUrl = addProductsEndpoint;
    const request = new XMLHttpRequest();
    request.open('POST', requestUrl, true);
    request.setRequestHeader('Content-type', 'application/json');
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        const responseData = JSON.parse(request.responseText);
        // console.log(responseData);
        responseData.errorType = responseData['error-type'];
        if (responseData.errorType === 5) {
          setStoreGroupValues(responseData);
          onOrderNumberLookupSuccess(responseData);
        } else {
          // Display error message
          defaultErrorMsg.classList.remove('hide');
          enableUiBtn({
            btn: findOrderBtn,
            className: 'btn--disabled',
            label: defaultBtnLabel,
          });
        }
        displaySaveResponseMessages(responseData);
      } else {
        // Display error message
        defaultErrorMsg.classList.remove('hide');
        enableUiBtn({
          btn: findOrderBtn,
          className: 'btn--disabled',
          label: defaultBtnLabel,
        });
        /* onOrderNumberLookupSuccess({
          'order-number': 1658049,
          'line-items': [1, 2, 3],
          'store-group': '4009',
          'store-group-description': 'SWF MFG GRABER DIRECT CANADA DIV 01',
          message: null,
          success: true,
          'error-type': 5,
        }); */
      }
    };
    request.onerror = () => {
      // Display error message
      defaultErrorMsg.classList.remove('hide');
      enableUiBtn({
        btn: findOrderBtn,
        className: 'btn--disabled',
        label: defaultBtnLabel,
      });
    };
    request.send(JSON.stringify({
      UserId: getUserId(),
      OrderNumber,
    }));
  };

  const clearSessionData = () => {
    const { sessionStorage } = window;
    sessionStorage.removeItem('bali_ppData');
  };

  const submitLead = (callback) => {
    const { storeGroup, storeGroupDescription } = orderData;
    // console.log(`${storeGroup}, ${storeGroupDescription}`);
    const { sessionStorage } = window;
    let userData = {};
    const sessionObj = sessionStorage.getItem('bali_ppData');
    if (sessionObj !== null) {
      userData = JSON.parse(sessionObj);
    }
    userData.page_submitted_from = window.location.href; // Submit w/ page title
    userData.customer_store_group = storeGroup;
    userData.customer_store_group_description = storeGroupDescription;
    userData.success = () => {
      callback();
    };
    userData.failure = () => {
      callback();
    };
    const { _dcq } = window;
    _dcq.push([
      'identify',
      userData,
    ]);
    clearSessionData();
  };
  // Init
  findOrderBtn.addEventListener('click', orderNumberLookup);
  completeRegistrationBtn.addEventListener('click', (event) => {
    event.preventDefault();
    const {
      isAuthenticated,
      thankYouAuthenticatedLink,
      thankYouNoAccountLink,
    } = window;
    const orderNumber = getProductCodeEntry();
    const urlParams = `?redirect=true&orderno=${orderNumber}`;
    if (checkForSessionData()) {
      // Save lead
      submitLead(() => {
        if (isAuthenticated) {
          console.log('authenticated redirect');
          window.location = thankYouAuthenticatedLink + urlParams;
        } else {
          console.log('no account redirect');
          window.location = thankYouNoAccountLink + urlParams;
        }
      });
    } else {
      if (isAuthenticated) { /* eslint-disable-line no-lonely-if */
        console.log('authenticated redirect');
        window.location = thankYouAuthenticatedLink + urlParams;
      } else {
        console.log('no account redirect');
        window.location = thankYouNoAccountLink + urlParams;
      }
    }
  });
};
export default addProducts;
/* eslint-enable no-console */
